<template>
  <section>
    <nav-base
      title="Actividad"
      :showBack="true"
      :headerInfo="
        `Curso: ${currentCourse.course_title}\nMódulo: ${currentModule.module_name}\nActividad: ${currentLesson.lesson_title}`
      "
    />
    <Loader v-if="cargando" />
    <div v-if="!cargando" class="card">
      <v-layout row wrap>
        <v-flex offset-lg1 offset-md1 offset-xs1>
          <h5 class="mt-5">
            {{ lesson.lesson_title }}
          </h5>
        </v-flex>
        <template>
          <v-flex
            xs10
            sm10
            md10
            offset-lg1
            offset-md1
            offset-xs1
            lg10
            v-if="
              lessonContent &&
                typeContent === 2 &&
                currentCourse.active_sence === 1
            "
          >
            <div class="py-4">
              <iframe
                :src="lessonContent.lesson_content"
                style="width:100%;height:80vh;"
                frameborder="0"
                webkitallowfullscreen
                mozallowfullscreen
                allowfullscreen
                :onload="frameLoaded()"
              ></iframe>
            </div>
          </v-flex>
          <v-flex
            xs10
            sm10
            md10
            offset-lg1
            offset-md1
            offset-xs1
            lg10
            v-if="
              lessonContent &&
                typeContent === 1 &&
                currentCourse.active_sence === 1
            "
          >
            <iframe
              class="video-vimeo"
              :src="lessonContent.lesson_content"
              frameborder="0"
              height="478"
              scrolling="no"
              marginheight="0"
              gesture="media"
              allow="encrypted-media"
              allowfullscreen
              name="slideshow"
            ></iframe>
          </v-flex>
          <v-flex
            xs10
            sm10
            md10
            offset-lg1
            offset-md1
            offset-xs1
            class="m-0 pb-5"
          >
            <div>
              <div
                class="parent-style"
                style="display: flex; flex-direction: column;"
              >
                <Toolbar
                  v-if="lesson.lesson_start_date || lesson.lesson_end_date"
                >
                  <template #start>
                    <span class="label-card">FECHA</span>
                  </template>
                  <template #end>
                    {{
                      lesson.lesson_start_date
                        ? new Date(lesson.lesson_start_date).toLocaleString()
                        : ""
                    }}
                    -
                    {{
                      lesson.lesson_end_date
                        ? new Date(lesson.lesson_end_date).toLocaleString()
                        : ""
                    }}
                  </template>
                </Toolbar>
                <!-- <Toolbar v-if="lesson.meeting">
                  <template #start>
                    <span class="label-card"
                      >AULA DE CLASES (HR INICIO / HR TÉRMINO)</span
                    >
                  </template>
                  <template #end>
                    {{ formatHour(lesson.lesson_start_date) }} -
                    {{ formatHour(lesson.lesson_end_date) }}
                  </template>
                </Toolbar> -->
                <Toolbar v-if="lesson.meeting">
                  <template #start>
                    <div class="p-grid">
                      <div class="p-col-12">
                        <h6 class="label-card">
                          Descripción de la videoconferencia
                        </h6>
                      </div>
                      <div class="p-col-12">
                        <span>Puede unirse a la sesión.</span>
                      </div>
                      <div
                        v-if="!isAStudent"
                        class="p-col-12 p-d-flex p-jc-between p-ai-center"
                      >
                        <Button
                          :label="
                            lesson.meeting_active
                              ? 'Finalizar Sesión'
                              : 'Unirse a la Sesión'
                          "
                          class="p-button-raised"
                          @click="openVideoConference()"
                        />
                      </div>
                      <StudenLessonMeeting
                        v-else
                        :lesson="lesson"
                        :lessons_check="lesson.lessons_check"
                      />
                      <div class="p-col-12">
                        <h6 class="label-card">Grabaciones</h6>
                      </div>
                      <div class="p-col-12" v-if="lesson.recordings.length > 0">
                        <v-list class="mt-1">
                          <v-list-tile
                            v-for="recording in lesson.recordings"
                            class="lighten-4 mb-1"
                            v-bind:key="recording.id"
                            @click="linkTo(recording.recording_link)"
                            avatar
                          >
                            <v-list-tile-avatar>
                              <div class="avatar-p">
                                <i
                                  style="font-size: 15px;"
                                  class="pi pi-video"
                                ></i>
                              </div>
                            </v-list-tile-avatar>
                            <v-list-tile-content>
                              <v-list-tile-title>
                                <div
                                  class="p-text-nowrap secondaryText--text"
                                  style="width: 3rem"
                                >
                                  <p class="body-1">
                                    {{ recording.recording_description }}
                                  </p>
                                </div>
                              </v-list-tile-title>
                            </v-list-tile-content>
                          </v-list-tile>
                        </v-list>
                      </div>
                      <div class="p-col-12" v-else>
                        <span>No hay grabación para esta reunión.</span>
                      </div>
                    </div>
                  </template>
                </Toolbar>
                <div class="section-activity">
                  <span class="label-card">DESCRIPCIÓN</span>
                  <span>{{ lesson.lesson_text }}</span>
                </div>
                <div class="section-activity">
                  <span class="label-card">DETALLE ACTIVIDADES</span>
                  <span>{{ lesson.lesson_about }}</span>
                </div>
                <LessonArchives
                  :archives="lesson.archives"
                  :archives_check="lesson.archives_check"
                />
                <LessonLinks
                  :links="lesson.links"
                  :links_check="lesson.links_check"
                />
              </div>
            </div>
          </v-flex>
        </template>
      </v-layout>
    </div>
  </section>
</template>
<script>
import Role from "@/utils/role";
import { mapState } from "vuex";
import * as moment from "moment";
import { VueChatScroll } from "vue-chat-scroll";
import { vueVimeoPlayer } from "vue-vimeo-player";
import { leccionService } from "@/services/Leccion.service";
import CredentialsServices from "@/services/Credentials.service.js";
import { sectionUserService } from "@/services/SectionsUsers.service";
import lessonService from "@/services/axios/lesson.service";
// import fileService from "@/services/axios/file.service";
import StudenLessonMeeting from "./StudenLessonMeeting.vue";
import LessonArchives from "./LessonArchives.vue";
import LessonLinks from "./LessonLinks.vue";
export default {
  data() {
    return {
      credentialService: new CredentialsServices(),
      videoID: "",
      typeContent: 0,
      lesson: {
        autor: {
          avatar: ""
        }
      },
      lessonContent: null,
      drawer: null,
      cargando: true
    };
  },
  components: {
    vueVimeoPlayer,
    VueChatScroll,
    StudenLessonMeeting,
    LessonArchives,
    LessonLinks
  },
  mounted() {
    this.loadLeccion();
  },
  computed: {
    ...mapState({
      role: state => state.role,
      currentCourse: state => state.navigation.currentCourse,
      currentModule: state => state.navigation.currentModule,
      currentLesson: state => state.navigation.currentLesson
    }),
    isAStudent() {
      return this.role === Role.STUDENT;
    }
  },
  watch: {
    currentLesson: {
      handler() {
        this.cargando = true;
        this.loadLeccion();
      }
    }
  },
  methods: {
    // socketConnect () {
    //   let vm = this
    //   console.log("lesson" + this.currentLesson.id + "blogEvent")
    //   vm.$socket.on("lesson" + this.currentLesson.id + "blogEvent", function (data) {
    //     console.log("lesson" + this.currentLesson.id + "blogEvent")
    //   })
    // },
    loadLeccion() {
      let vm = this;
      leccionService.getById(vm.currentLesson.id).then(({ data }) => {
        if (data.lesson_content) {
          this.lessonContent = data.lesson_content;
          this.typeContent = data.type_lesson_id;
        }
        vm.lesson = data;
        this.cargando = false;
        if (this.isAStudent) {
          vm.submitSeccionUsuario();
        }
      });
    },
    pruebasocket() {
      leccionService.query().then(data => {});
    },
    submitSeccionUsuario() {
      const data = { lesson_id: this.lesson.id };
      sectionUserService.save(data).then(
        data => {},
        response => {}
      );
    },
    frameLoaded() {
      this.cargando = false;
    },
    openVideoConference() {
      lessonService
        .toogleLessonMeetingAtive(this.lesson.id)
        .then(({ data }) => {
          this.lesson.meeting_active = !this.lesson.meeting_active;
          if (this.lesson.meeting_active) {
            let route = this.$router.resolve({ name: "LessonMeet" });
            window.open(route.href);
          }
        });
    },
    goVideoConference() {
      let route = this.$router.resolve({ name: "LessonMeet" });
      window.open(route.href);
    },
    verLeccion(id) {
      const name = this.isAStudent ? "LessonDetail" : "TeacherLessonDetail";
      this.$router.push({
        name,
        params: { id: id, curso_id: this.curso_id }
      });
    },
    stop() {
      this.$refs.player.stop();
    },
    linkTo(link) {
      window.open(`${link}`, "_blank");
    },
    formatDate(value) {
      return moment(value).format("L");
    },
    formatHour(value) {
      return moment(value).format("HH:mm");
    },
    descargarArchivo(id) {
      window.location.href = `${process.env.address.api}download/archives/${id}`;
    }
  }
};
</script>

<style scoped>
.video-vimeo {
  width: 100%;
}

.label-card {
  color: #616161;
  font-weight: 600;
}

.parent-style > * {
  margin: 3px 0;
  background-color: white;
}

.section-activity {
  background-color: white;
  border: 1px solid #dee2e6;
  padding: 1rem;
  border-radius: 3px;
  display: flex;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica,
    Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";
  flex-direction: column;
}
.avatar-p {
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
  width: 40px;
  height: 40px;
  background-color: #00897b;
  border-radius: 50%;
}
</style>



// WEBPACK FOOTER //
// src/components/Leccion/ShowLeccion.vue